export enum ScheduleViewOption {
  SHOW_AVAILABILITIES = 'showAvailabilities',
  HIDE_EMPTY_ROWS = 'hideEmptyRows',
}
